export const UPDATE_ORDER = 'UPDATE_ORDER';
export const UPDATE_SHOP_SETTING = 'UPDATE_SHOP_SETTING';
export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_ORDER_COUNT = 'UPDATE_ORDER_COUNT';
export const UPDATE_CURRENT_ADDRESS = 'UPDATE_CURRENT_ADDRESS';
export const IS_FETCH_USER = 'IS_FETCH_USER';
export const UPDATE_CURRENT_LOCATION = 'UPDATE_CURRENT_LOCATION';
export const UPDATE_LOADER_GOOGLE = 'UPDATE_LOADER_GOOGLE';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const APPLY_PROMOTION = 'APPLY_PROMOTION';
export const SPENING = 'SPENING';
export const GET_ORDER_SERVICE_DETAIL = 'GET_ORDER_SERVICE_DETAIL';
